/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '@app/@core/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-whats-new',
  templateUrl: './whats-new.component.html',
  styleUrls: ['./whats-new.component.scss']
})
export class WhatsNewWidgetComponent implements OnInit, OnDestroy {
  private dataSub: Subscription;

  notices = [];
  notices_loaded: boolean = false;

  constructor(private apiService: ApiService) {}

  ngOnInit() {
    this.getNotices();
  }

  ngOnDestroy() {
    if (this.dataSub) this.dataSub.unsubscribe();
  }

  getNotices() {
    this.notices = [];
    this.notices_loaded = false;
    this.dataSub = this.apiService.get('dashboard/notices').subscribe((result) => {
      if (!result.error) {
        this.notices = result.data;
        this.notices_loaded = true;
      }
    });
  }

  removeHTML(text) {
    return text.replace(/<[^>]*>/g, '');
  }
}
